export const APPLICATION_START_ACTION = "application/START";

export default function applicationStartAction() {
  return {
    "payload": {},
    "type": APPLICATION_START_ACTION
  };
}
